import { REACT_APP__URL_SMP_API } from "@smp/utils";
import { apiRequest } from "../../../lib";
export class ApiSmpGptPrompt {
}
ApiSmpGptPrompt.list = (req) => apiRequest({
    endpoint: REACT_APP__URL_SMP_API + "/gpt/v1/prompt/",
    method: "GET",
    query: req === null || req === void 0 ? void 0 : req.query,
});
ApiSmpGptPrompt.create = (body) => apiRequest({
    body,
    endpoint: REACT_APP__URL_SMP_API + "/gpt/v1/prompt/",
    method: "POST",
});
ApiSmpGptPrompt.retrieve = (id) => apiRequest({
    endpoint: REACT_APP__URL_SMP_API + "/gpt/v1/prompt/" + id,
    method: "GET",
});
ApiSmpGptPrompt.delete = (id) => apiRequest({
    endpoint: REACT_APP__URL_SMP_API + "/gpt/v1/prompt/" + id,
    method: "DELETE",
});
//# sourceMappingURL=prompt.js.map